import { QueryClient } from '@tanstack/react-query';
import ms from 'ms';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      structuralSharing: true,
      retry: import.meta.env.MODE === 'production' ? 3 : false,
      retryDelay: 5000,
      gcTime: ms('10m'),
      staleTime: ms('5m'),
    },
    mutations: {
      gcTime: 0,
    },
  },
});

export default queryClient;
